export var figureMap = {
  1: 'Dünn',
  2: 'Athletisch',
  3: 'Muskulös',
  4: 'Durchschnittlich',
  5: 'Stämmig',
  6: 'Mollig',
  7: 'Dick'
};